import React from 'react';
import { motion } from 'framer-motion';
import { FaCode, FaPalette, FaMobile } from 'react-icons/fa';
import AnimatedProgressBar from './AnimatedProgressBar'; // Ensure the path is correct

const About = () => {
  const skills = [
    { name: 'HTML/CSS', level: 100 },
    { name: 'JS/TS', level: 100 },
    { name: 'React', level: 100 },
    { name: 'Wizardry', level1: 100, level2: 200 },
  ];

  const getCircleSize = (level) => {
    const minSize = 8;
    const maxSize = 16;
    return minSize + (maxSize - minSize) * (level / 100);
  };

  return (
    <section id="about" className="py-20 bg-gray-50 dark:bg-gray-900">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title text-center">About Me</h2>

          <div className="flex flex-col md:flex-row gap-10 mt-10">
            <div className="md:w-1/2">
              <p className="text-lg mb-6 text-text-light dark:text-text-dark">
                I'm a passionate web developer with a strong focus on creating responsive,
                user-friendly applications. With 5 years of experience in front-end development,
                I enjoy bringing ideas to life through code.
              </p>
              <p className="text-lg text-text-light dark:text-text-dark">
                My journey in web development started with HTML and CSS, and I've since
                expanded my skills to include modern JavaScript frameworks like React.
                I'm constantly learning and exploring new technologies to stay at the
                forefront of web development.
              </p>

              <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="p-4 bg-white dark:bg-gray-800 rounded-lg shadow-md text-center">
                  <FaCode className="text-4xl mx-auto mb-4 text-primary-light dark:text-primary-dark" />
                  <h3 className="font-bold text-lg mb-2 text-text-light dark:text-text-dark break-words">Web Development</h3>
                </div>
                <div className="p-4 bg-white dark:bg-gray-800 rounded-lg shadow-md text-center">
                  <FaPalette className="text-4xl mx-auto mb-4 text-primary-light dark:text-primary-dark" />
                  <h3 className="font-bold text-lg mb-2 text-text-light dark:text-text-dark break-words">UI/UX Design</h3>
                </div>
                <div className="p-4 bg-white dark:bg-gray-800 rounded-lg shadow-md text-center">
                  <FaMobile className="text-4xl mx-auto mb-4 text-primary-light dark:text-primary-dark" />
                  <h3 className="font-bold text-lg mb-2 text-text-light dark:text-text-dark break-words">Responsive Design</h3>
                </div>
              </div>
            </div>

            <div className="md:w-1/2">
              <h3 className="text-xl font-bold mb-6 text-text-light dark:text-text-dark">Skills</h3>
              <div className="space-y-6">
                {skills.map((skill) => (
                  <div key={skill.name}>
                    <div className="flex justify-between mb-2">
                      <span className="font-medium text-text-light dark:text-text-dark">{skill.name}</span>
                      <div className="flex items-center">
                        <div
                          className="rounded-full bg-primary-light dark:bg-primary-dark"
                          style={{ width: `${getCircleSize(skill.level1 || skill.level)}px`, height: `${getCircleSize(skill.level1 || skill.level)}px` }}
                        ></div>
                      </div>
                    </div>
                    <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2.5 relative">
                      {skill.level1 ? (
                        <>
                          <AnimatedProgressBar duration={skill.level1 / 15} />
                          <div className="absolute top-1/2 transform -translate-y-1/2 w-full">
                            <AnimatedProgressBar duration={skill.level2 / 15} />
                          </div>
                        </>
                      ) : (
                        <AnimatedProgressBar duration={skill.level / 15} />
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;